import { render, staticRenderFns } from "./WarrantyBenefitSetting.vue?vue&type=template&id=22ae9bc8&scoped=true&"
import script from "./WarrantyBenefitSetting.vue?vue&type=script&lang=js&"
export * from "./WarrantyBenefitSetting.vue?vue&type=script&lang=js&"
import style0 from "./WarrantyBenefitSetting.vue?vue&type=style&index=0&id=22ae9bc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ae9bc8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard,VCardText})
